
import { useParams } from "react-router-dom";
import { stories } from "../data/stories";
import { Header } from "../components/Header";
import { Story } from "../data/story-template";

const StoryPage = () => {
  const { id } = useParams();
  const story = stories.find(s => s.id === id) as Story | undefined;

  if (!story) {
    return (
      <div>
        <Header />
        <div className="container mx-auto px-4 py-8">
          <h1 className="text-2xl font-bold">Story not found</h1>
        </div>
      </div>
    );
  }

  const formatText = (text: string) => {
    // First replace **text** with bold text (must be before single * for italics)
    let formattedText = text.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>');
    
    // Then replace _text_ or *text* with italicized text
    formattedText = formattedText.replace(/[_*](.*?)[_*]/g, '<em>$1</em>');
    
    // Then replace ^text^ with superscript text
    formattedText = formattedText.replace(/\^(.*?)\^/g, '<sup>$1</sup>');
    
    return formattedText;
  };

  return (
    <div>
      <Header />
      <article className="container mx-auto px-4 py-8 max-w-2xl">
        <header className="mb-8">
          <h1 className="text-4xl font-bold mb-4 text-story-text">{story.title}</h1>
          <div className="flex items-center justify-between text-gray-600 mb-6">
            <span>{story.author}</span>
            <span>{story.date}</span>
          </div>
          {story.warning && (
            <div className="bg-[#D46F4D] text-white px-4 py-2 rounded-lg mb-6">
              {story.warning}
            </div>
          )}
        </header>
        <div className="prose prose-lg max-w-none">
          {story.image && (
            <img 
              src={story.image} 
              alt="Story header image"
              className="float-right ml-4 mb-4 w-1/3 rounded-lg shadow-lg"
            />
          )}
          {story.content.split('\n').map((paragraph, index) => {
            const trimmedParagraph = paragraph.trim();
            let alignment = '';
            let content = paragraph;
            
            if (trimmedParagraph === '***') {
              alignment = 'text-center';
            } else if (trimmedParagraph.startsWith('>>>')) {
              alignment = 'text-right';
              content = trimmedParagraph.substring(3).trim();
            }
            
            return (
              <p 
                key={index} 
                className={alignment}
                dangerouslySetInnerHTML={{ __html: formatText(content) }}
              />
            );
          })}
        </div>
        {story.relatedStory && (
          <div className="mt-8 pt-6 border-t border-gray-200">
            <a 
              href={`/story/${story.relatedStory.id}`}
              className="text-primary hover:underline italic"
            >
              {story.relatedStory.caption}
            </a>
          </div>
        )}
      </article>
    </div>
  );
};

export default StoryPage;
